import { render, staticRenderFns } from "./my-upload3.vue?vue&type=template&id=37667932&scoped=true"
import script from "./my-upload3.vue?vue&type=script&lang=js"
export * from "./my-upload3.vue?vue&type=script&lang=js"
import style0 from "./my-upload3.vue?vue&type=style&index=0&id=37667932&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37667932",
  null
  
)

export default component.exports